/* src/app/shared/dialog/screen-dialog/screen-spots/screen-spots.component.scss */
.custom-header {
  background-color: rgba(36, 70, 102, 0.05);
}
.custom-header .mat-header-cell {
  border-bottom: 1px solid #DFEBF7;
  color: #001A33;
  text-align: center;
  font: 700 12px FranceTV Brown;
}
.table {
  border: 1px solid #DFEBF7;
  border-radius: 5px;
  margin-top: 15px;
  overflow: auto;
  height: calc(100vh - 260px) !important;
}
.mat-column-campaign,
.mat-column-durspot,
.mat-column-emplaceCode,
.mat-column-caInit,
.mat-column-caNet,
.mat-column-utPlanning,
.mat-column-priceSector {
  width: 6%;
}
.mat-column-screenDate,
.mat-column-product,
.mat-column-productType,
.mat-column-advertiser,
.mat-column-abatt {
  width: 12%;
}
.mat-cell.mat-cell-center-align {
  text-align: center;
  color: #001A33;
  font: 400 12px FranceTV Brown;
}
.reserve-icon {
  width: 20px;
  height: 20px;
  padding-right: 4px !important;
}
/*# sourceMappingURL=screen-spots.component.css.map */
